const initialState = {
  bannerId: ''
};

export default function banner (state = initialState, action) {
  const { bannerId, type } = action;

  if ('TOGGLE_BANNER' === type) {
    return { ...state, bannerId };
  }

  if ('CLEAR_BANNER' === type) {
    return { ...state, bannerId };
  }

  return state;
}
